import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import photoKids from '../assets/image/hero2.jpg';
import "../styles/Hero.css";

function Hero() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="hero-section dark-theme">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge-container">
            <span className="hero-badge-outline">{t('hero.badge')}</span>
          </div>
          <h1 className="hero-title">
            {t('hero.title1')} <br />
            <span className="keyword">{t('hero.title2')}</span>
          </h1>
          <p className="hero-description">
            {t('hero.desc')}
          </p>
          <div className="hero-btns">
            <button className="btn-primary" onClick={() => navigate('/projets')}>
              {t('hero.btn')}
            </button>
          </div>
        </div>
      </div>

      {/* L'image fusionnée avec le fond */}
      <div className="hero-image-overlay">
        <img src={photoKids} alt="Activités Tiwizi" className="hero-bg-img" />
        <div className="image-gradient-mask"></div>
      </div>

      {/* Cercles concentriques */}
      <div className="hero-concentric-circles">
        <div className="circle-1"></div>
        <div className="circle-2"></div>
        <div className="circle-3"></div>
      </div>

      {/* Vague de séparation */}
      <div className="hero-wave">
        <svg viewBox="0 0 1440 200" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="var(--background-solid)" fillOpacity="1" d="M0,200 L0,50 C 100,100 1000,200 1440,0 L1440,200 Z"></path>
        </svg>
      </div>
    </section>
  );
}

export default Hero;
